import React from 'react';
import { ArrowRight } from 'lucide-react';
interface FlowStepsProps {
  steps: string[];
  tone?: 'light' | 'dark';
  align?: 'start' | 'center';
  size?: 'sm' | 'lg';
  label?: string;
}
export function FlowSteps({
  steps,
  tone = 'light',
  align = 'center',
  size = 'sm',
  label
}: FlowStepsProps) {
  const chipTone = tone === 'dark' ? 'bg-white/10 text-white border-white/20' : 'bg-white text-zinc-950 border-zinc-200';
  const arrowTone = tone === 'dark' ? 'text-violet-300' : 'text-violet-600';
  const chipSize = size === 'lg' ? 'px-5 py-2.5 text-base md:text-lg' : 'px-3 py-1.5 text-xs md:text-sm';
  return <ol aria-label={label ?? steps.join(' to ')} className={`flex flex-wrap items-center gap-x-2 gap-y-2 ${align === 'center' ? 'justify-center' : 'justify-start'}`} data-id="element-113" data-mp="2pww4x6iqtsse">
      {steps.map((step, index) => <li key={step} className="flex items-center gap-2" data-id="element-114" data-mp="3nct9zm2d0r9x" data-mpi={index}>
          <span className={`font-display font-extrabold uppercase tracking-wide rounded-lg border whitespace-nowrap ${chipTone} ${chipSize}`} data-id="element-115" data-mp="3nee2l6546055">
            {step}
          </span>
          {index < steps.length - 1 && <ArrowRight size={size === 'lg' ? 20 : 16} className={`shrink-0 ${arrowTone}`} aria-hidden="true" data-id="element-116" data-mp="h6z2v8th3k1y" />}
        </li>)}
    </ol>;
}